<template>
    <div>
        <div class="navbar-default navbar-fixed-top">
            <br/>
            <br/>
            <div>
                <img style="margin-left: 45%; margin-top: -55px" src="https://www.numier.com/clientes/images/logo_completo.png"/>
            </div>
        </div>
        <div>
            <div style="margin-left: auto; margin-right: auto" class="col-md-10">
                <div class="jumbtron">
                    <h1 class="display-4">{{$t('condicionesDeNumierOnline')}}</h1>
                    <p class="lead"><p style="text-align:justify; height:120px; overflow-x:auto"><strong>{{$t('descripcionDelServicio')}}</strong>
                    <br>
                    {{$t('terminosIntroduccionParte1')}}
                    <br>
                    {{$t('terminosIntroduccionParte2')}}
                    <br>
                    {{$t('terminosIntroduccionParte3')}}
                    <br>
                    {{$t('terminosIntroduccionParte4')}}
                    <br>
                    <strong>{{$t('politicaDePrivacidad')}}</strong>
                    <br>
                    {{$t('privacidadParte1')}}
                    <br>
                    {{$t('privacidadParte2')}}
                    <br>
                    {{$t('privacidadParte3')}}
                    <br>
                    {{$t('privacidadParte4')}}
                    <br>
                    {{$t('privacidadParte5')}}
                    <br>
                    {{$t('privacidadParte6')}} 
                    <br>
                    {{$t('privacidadParte7')}}
                    <br>
                    {{$t('privacidadParte8')}}
                    <br>
                    {{$t('privacidadParte9')}}
                    <br>
                    {{$t('privacidadParte10')}}
                    <br>
                    {{$t('privacidadParte11')}}
                    <br>
                    {{$t('privacidadParte12')}}
                    <br>
                    {{$t('privacidadParte13')}}
                    <br>{{$t('privacidadParte13dos')}} 
                    <br>{{$t('privacidadParte13tres')}}
                    <br>{{$t('privacidadParte13cuatro')}}
                    <br>{{$t('privacidadParte13cinco')}}
                    <br>{{$t('privacidadParte14')}}<br></p>
                    <p>
                    <hr class="my-4">
                    <p>
                        <button class="btn btn-success" @click="acceptTerms()">{{$t('acepto')}}</button>
                    </p>
                    <!--<p class="lead">-->
                        <!--<a class="btn btn-primary btn-lg" href="#" role="button">Learn more</a>-->
                    <!--</p>-->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Terms",

        created(){

        },
        methods: {
            acceptTerms(){

                var config = {
                    params: {
                        jwt: this.$store.getters.jwt,
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "updateTerms", config)
                    .then(function (response) {

                        if (response.data.response) {
                            vm.$router.push({
                                path: '/'
                            })

                        }else{

                            swal({
                                title: vm.$t('atencion'),
                                text: response.data.message,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });

            }
        }
    }
</script>

<style scoped>
    .navbar-default {
        background-color: #004050;
        border-color: #004050;
        height: 65px;
    }

    .navbar-fixed-top {
        top: 0;
        border-width: 0 0 1px;
    }
</style>


// WEBPACK FOOTER //
// src/pages/GeneralViews/Terms.vue